import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A grid operations / dispatch building: a two-storey block with a glazed
// control-hall front, a flat roof carrying a microwave dish and antenna mast,
// and a small entrance canopy. Where the network is watched and switched.
const WALL = "#b9bcc0";
const WALL_DK = "#9aa0a6";
const GLASS = "#3a5a6e";
const GLASS_LT = "#4f7e96";
const ROOF = "#73787e";
const STEEL = "#878e96";

export const controlRoom = defineModel({
  id: "control-room",
  batchId: "electric",
  name: "Control room",
  tags: ["building", "electric", "power", "grid", "control", "scada"],
  summary: "A glazed operations building with rooftop dish and antenna.",
  footprint: 0.9,
  parts(): Part[] {
    const parts: Part[] = [
      { geometry: new THREE.BoxGeometry(1.7, 0.1, 1.2), color: "#6f6f74", position: [0, 0.05, 0] },
      // Two-storey block.
      { geometry: new THREE.BoxGeometry(1.4, 0.86, 0.9), color: WALL, position: [0, 0.53, 0] },
      { geometry: new THREE.BoxGeometry(1.46, 0.08, 0.96), color: ROOF, position: [0, 0.99, 0] },
      // Glazed control-hall curtain wall on the front.
      { geometry: new THREE.BoxGeometry(1.2, 0.62, 0.04), color: GLASS, position: [0, 0.5, 0.46] },
    ];
    // Window mullions (a grid of lighter glass panes).
    for (const y of [0.34, 0.66]) for (let i = 0; i < 4; i++) {
      parts.push({ geometry: new THREE.BoxGeometry(0.24, 0.24, 0.02), color: GLASS_LT, position: [-0.45 + i * 0.3, y, 0.48] });
    }
    parts.push(
      // Entrance canopy.
      { geometry: new THREE.BoxGeometry(0.4, 0.04, 0.2), color: WALL_DK, position: [0, 0.3, 0.56] },
      { geometry: new THREE.BoxGeometry(0.16, 0.28, 0.02), color: "#3a4046", position: [0, 0.24, 0.47] },
      // Rooftop microwave dish on a short mast.
      { geometry: new THREE.CylinderGeometry(0.02, 0.02, 0.3, 6), color: STEEL, position: [-0.5, 1.15, -0.2] },
      { geometry: new THREE.CylinderGeometry(0.001, 0.16, 0.1, 14), color: "#cfd2d4", position: [-0.5, 1.32, -0.12], rotation: [1.1, 0, 0] },
      // Antenna mast.
      { geometry: new THREE.CylinderGeometry(0.015, 0.02, 0.7, 6), color: STEEL, position: [0.5, 1.34, -0.2] },
      { geometry: new THREE.BoxGeometry(0.18, 0.02, 0.02), color: STEEL, position: [0.5, 1.5, -0.2] },
      { geometry: new THREE.BoxGeometry(0.18, 0.02, 0.02), color: STEEL, position: [0.5, 1.42, -0.2] },
    );
    return parts;
  },
  animations: [],
});
